import { render, staticRenderFns } from "./PermissionAssignment.vue?vue&type=template&id=3d229535&scoped=true&"
import script from "./PermissionAssignment.vue?vue&type=script&lang=js&"
export * from "./PermissionAssignment.vue?vue&type=script&lang=js&"
import style0 from "./PermissionAssignment.vue?vue&type=style&index=0&id=3d229535&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d229535",
  null
  
)

export default component.exports